import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  CircularProgress,
  Alert,
} from "@mui/material";
import { useDeleteDocument } from "../../../../hooks/panelEditor/useDeleteDocument";

export const DesactiveDocumentModal = ({ isOpen, onClose, token, documentData, onSuccess }) => {
  const { deleteDocument, loading, error } = useDeleteDocument(token);
  const isCurrentlyActive = documentData?.FLG_ACTIVO === 1 || documentData?.FLG_ACTIVO === "1";
  const newFlgActivo = isCurrentlyActive ? 0 : 1; 
  const documentName = documentData?.NOMBRE_DOCUMENTO || "Documento sin nombre";
  const documentId = documentData?.ID_DOCUMENTO;

  const handleConfirm = async () => {
    if (!documentId) return;
    
    const result = await deleteDocument(documentId, newFlgActivo);
    if (result.success) {
      if (onSuccess) onSuccess(result.data);
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onClose={!loading ? onClose : undefined} fullWidth maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 600 }}>
        {isCurrentlyActive ? "¿Eliminar Documento?" : "¿Activar Documento?"}
      </DialogTitle>
      
      <DialogContent sx={{ display: "flex", flexDirection: "column", gap: 2, pt: 2 }}>
        {error && <Alert severity="error">{error}</Alert>}
        
        <DialogContentText>
          Estás a punto de <strong>{isCurrentlyActive ? "eliminar" : "activar"}</strong>{" "}
          el documento "{documentName}". 
          {isCurrentlyActive && " Esta acción ocultará el documento de las vistas públicas."}
          {" ¿Deseas continuar?"}
        </DialogContentText>
      </DialogContent>
      
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} disabled={loading} color="inherit" sx={{ borderRadius: "8px" }}>
          Cancelar
        </Button>
        <Button
          onClick={handleConfirm}
          color={isCurrentlyActive ? "error" : "success"}
          variant="contained"
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
          disableElevation
          autoFocus
          sx={{ borderRadius: "8px" }}
        >
          {isCurrentlyActive ? "Eliminar" : "Activar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
